import React, { ForwardedRef, forwardRef, memo } from 'react'
import Button from '@mui/material/Button'
import StyledLink from 'components/StyledLink'
import useStyles from './styles'

interface IPageHeaderPrimaryButtonProps {
  href?: string
  onClick?: () => void
  'data-cy'?: string
  children: React.ReactNode
}

// TODO: fix messy ForwardedRef typings
function PageHeaderPrimaryButton(props: IPageHeaderPrimaryButtonProps, ref: ForwardedRef<any>) {
  const { href, onClick, children, 'data-cy': dataCy } = props
  const { classes } = useStyles()

  if (href) {
    return (
      <Button
        ref={ref}
        variant="outlined"
        fullWidth
        component={StyledLink}
        href={href}
        data-cy={dataCy}
        className={classes.button}
      >
        {children}
      </Button>
    )
  }

  return (
    <Button
      ref={ref}
      variant="outlined"
      fullWidth
      data-cy={dataCy}
      className={classes.button}
      onClick={onClick}
    >
      {children}
    </Button>
  )
}

export default memo(forwardRef(PageHeaderPrimaryButton))
